import React from 'react'

function Footer() {
  return (
    <div className="w-full h-[60vh] bg-gray-800"></div>
  )
}

export default Footer